<template>
  <q-layout view="hHh Lpr lff" :class="`bg-${colores.fondo}`">
      <inscripcionPage :colores="colores" :rules="rules" :user="user" @emitUserAutenticado="fnUserAutenticado" @emitCerrarSession="fnCerrarSesionUser"/>
  </q-layout>
</template>

<script>
import { defineComponent, defineAsyncComponent } from 'vue'
import { useStore } from '@/composables/store/useStore.js'
import { useTheme } from '@/composables/useThemes.js'
import { storeToRefs } from 'pinia'
import { useDialogo } from '@/composables/useDialogos.js'

export default defineComponent({
  name: 'InscripcionView',
  components: {
    inscripcionPage: defineAsyncComponent(() => import('@/pages/inscripcionPage.vue'))
  },
  setup (props, context) {
    // VARIABLES GLOBALES
    const { dialogoMsg } = useDialogo()
    const { fnColor1 } = useTheme(dialogoMsg)
    const store = useStore()
    store.setColores(fnColor1())
    const { user, colores } = storeToRefs(store)
    const rules = { requerido: v => !!v || 'Requerido', requeridoTrue: v => v === true || 'Requerido', email: v => (v === null || v.length === 0 || /.+@.+\..+/.test(v)) || 'E-mail invalido', telefono: v => (v.length === 0 || ((!isNaN(parseFloat(v)) && v >= 0 && (v.length === 7 || v.length === 10)))) || 'Número inválido', len7: v => (v === null || v.length === 0 || v.length === 7) || 'Debe ser igual a 7 digitos', len10: v => (v === null || v.length === 0 || v.length === 10) || 'Debe ser igual a 10 digitos', miles: v => (!isNaN(Number(v.toString().split(',').join('')))) || 'Numero invalido', numerico: v => (v.length === 0 || (!isNaN(parseFloat(v)) && v >= 0)) || 'Numero invalido', cero: v => (v && v !== 0 && v !== '0') || 'Requerido', iva: v => (v >= 1 && v <= 100) || 'Debe ser entre 1 a 100', array: v => (v.length > 0) || 'Requerido' }

    store.setUrlApi(process.env.VUE_APP_INI)
    store.setPrefix(process.env.VUE_APP_PREFIX)
    store.setRules(rules)
    store.setInbound([])
    colores.value = fnColor1()

    const userIni = store.getUser
    if (userIni !== null) {
      user.value = userIni
    }
    const fnUserAutenticado = (pUser) => {
      store.setUser(pUser)
      user.value = pUser
    }

    const fnCerrarSesionUser = () => {
      store.setUser(null)
      user.value = null
    }

    return { fnCerrarSesionUser, fnUserAutenticado, colores, rules, user }
  }
})
</script>
